import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M.325 21.333H31.66a31 31 0 0 1-.527 2.791s-1.028 4.918-5.476 6.646C23.567 31.6 19.75 31.966 16 32c-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.232-.93-.41-1.865-.54-2.79",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M.34 10.667h31.343c.254 1.844.336 3.663.314 5.35a35 35 0 0 1-.337 5.316H.325a35 35 0 0 1-.322-5.35c-.022-1.66.074-3.469.337-5.316",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#000",
      fillRule: "evenodd",
      d: "M.178 12h31.66c.133 1.384.175 2.738.159 4.016A35 35 0 0 1 31.822 20H.166a36 36 0 0 1-.163-4.017A35 35 0 0 1 .178 12",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#00A185",
      fillRule: "evenodd",
      d: "M31.683 10.667H.34c.131-.925.305-1.86.526-2.792 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263 4.448 1.728 5.477 6.646 5.477 6.646.22.916.39 1.84.516 2.758",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M2.865 3.82 12 16 2.865 28.18C1.308 26.237.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 .442-2.112 2-4.055",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "m7.57 19.04-2.477-1.66-2.467 1.652.953-2.66-2.49-1.64 3.066.015.929-2.665.942 2.67 3.064-.007-2.484 1.635z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M4.62 16.881c.13.131.42.184.697-.001.508-.249 1.49.001 1.49.001L7 16.698l-.471-1.385-.17-.162s-.362-.194-1.05-.13c-.69.065-.931-.021-.931-.021s-.605.065-.774.14l-.193.173L3 16.882z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#000",
      fillRule: "evenodd",
      d: "M2.381 17.98q.066.04.125 0l.565-.687.238-.299a.2.2 0 0 0 .045-.137l.203-.092.104.093.156.435.193-.138-.125-.447.272-.298-.102-.16.068-.092s.939.6 1.3.439c.01.003.022-.428.022-.428s-.972-.103-.995-.298c-.022-.195.306-.23.306-.23l.384-.332 2.261 2.614c.124-.05.15-.081.159-.206l-2.216-2.58.17-.183c.033-.038.045-.054.045-.115l.26-.229a.32.32 0 0 1 .17.138l.714-.614c.019.019.076.038.115.016L8 13l-1.333.888c0-.038.046-.048 0-.114-.05-.061-.125.057-.136.057s-.187-.063-.225-.143l-.013.212-.327.31-.25-.012-.361.355-.089.016c-.017.012-.228.236-.239.213l-.61-.699.034-.126-.385-.424c-.14-.05-.362-.058-.407.252-.035.073-.328.011-.328.011l-.158.035-.893 1.284.497.607 1.018-1.307.03-.37.213.242c.072.01.14.01.204-.023l.603.683-.157.053-.34.287-.01.057-1.007.848-.09.012-.023.263.057.103h-.09l-.34.344a.45.45 0 0 0-.237.07L2 17.526z",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagMoz = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagMoz_default = SvgFlagMoz;

export { FlagMoz_default as default };
